module.exports = __webpack_public_path__ + "static/media/fac3.6c55fd5e.jpg";